import { Table } from "../../components/Table/Table";
import "./MainPage.scss";

export const MainPage = () => {

  return (
    <Table />
  );
};
